// copied from apps/crm; consolidate into a shared package in S5 slice 4
// The one door: @aiw/api-client over services/api. In mock mode the same client
// talks to src/mock/server.ts through the fetch seam, so every page is built
// against the real contract from day 1.
import { createApiClient, api as calls, type ApiClient } from "@aiw/api-client";
import { env } from "./env";
import { sessionScope } from "./session-scope";
import { getTestSet } from "./testset";
import { mockFetch } from "../mock/server";

export const fetchImpl: typeof fetch = env.mock ? mockFetch : (input, init) => {
  const scope=sessionScope();
  const headers=new Headers(init?.headers??(input instanceof Request?input.headers:undefined));
  if(!scope.owner||!scope.token||headers.get('authorization')!==`Bearer ${scope.token}`)throw new Error('Account changed; request cancelled');
  return fetch(input,init);
};
const getToken=()=>{if(env.mock)return null;const s=sessionScope();if(!s.owner)throw new Error('Sign in required');return s.token;};

export const client: ApiClient = createApiClient({
  baseUrl: env.apiBase,
  surface: "installer",
  getToken,
  testSetId: getTestSet,
  fetch: fetchImpl,
});

export const api = calls;

/** Headers for hand-rolled requests (the SSE reader, the routes the typed client does not know yet). */
export async function authHeaders(): Promise<Record<string, string>> {
  const h: Record<string, string> = { "x-aiw-surface": "installer" };
  const t = await getToken();
  if (t) h.authorization = `Bearer ${t}`;
  const ts = getTestSet();
  if (ts) h["x-aiw-test-set"] = ts;
  return h;
}

/** `{ ok: true, data }` read for routes services/api does not expose in AppType yet
 *  (`/api/my-jobs`, `/api/work-orders/:ref`, `/api/statement`). A 404 reads as "nothing". */
export async function readData<T>(path: string, fallback: T): Promise<T> {
  const r = await fetchImpl(`${env.apiBase}${path}`, { headers: await authHeaders() });
  if (r.status === 404) return fallback;
  if (!r.ok) throw new Error(`api ${r.status}`);
  const j = (await r.json()) as { ok: true; data: T };
  return j.data;
}

/** Links into the live platform during the parallel run (ADR-005). */
export const platformLink = {
  workOrder: (installId: string) => `${env.platformBase}/cal/install/${installId}`,
  setOut: (installId: string) => `${env.platformBase}/cal/setout/${installId}`,
};

export const mapsLink = (address: string) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
